// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__H5E9m"};